import FrontNav from '../../front/components/FrontNav';
import FrontFooter from '../../front/components/FrontFooter';
import RosterType from './Component/RosterType';
function RosterSignUp() {
  return (
    <div className="front">
      <FrontNav />
      <section className="pt-4 pt-md-4 bg-gray-200">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <RosterType />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="position-relative mt-24">
        <div className="shape shape-bottom shape-fluid-x bg-text-dark">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <section className="pt-15 bg-dark" />
      <section className="py-8 py-md-11 bg-dark" />
      <div className="position-relative">
        <div className="shape shape-bottom shape-fluid-x text-gray-200">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default RosterSignUp;
